export function ServiceErrorOverlay() {
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-[#FAF8FD] p-6 text-center">
      <p className="text-lg font-medium text-[#1A1523]">
        Interview fatal error: contact employer
      </p>
    </div>
  )
}
